import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Building2Icon, ClockIcon, HomeIcon, MapPinIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { LanguageToggle } from './LanguageToggle';
import { ServicesMenu } from './ServicesMenu';
import { requestMarket } from '../utils/market';
import { useLanguage } from '../contexts/LanguageContext';
import { business, navItems } from '../data/business';
import { ui } from '../data/ui';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    t,
    lang
  } = useLanguage();
  const other = lang === 'en' ? 'es' : 'en';
  return <header className="sticky top-0 z-40 bg-navy shadow-[0_1px_0_rgba(255,255,255,0.08)]" data-id="element-154" data-mp="31ebbl7cohpvs">
      <div className="hidden border-b border-white/10 bg-navy-deep lg:block" data-id="element-155" data-mp="36cwb14k3w5j6">
        <div className="container-page flex items-center justify-between py-2 text-[13px] text-navy-soft" data-id="element-156" data-mp="3bbzhmtfqijt9">
          <div className="flex items-center gap-6" data-id="element-157" data-mp="3f9nei20zmmns">
            <a href={business.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 transition-colors duration-150 hover:text-white" data-id="element-158" data-mp="2wl4eqo7g82f5">
              <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-159" data-mp="2mmoosok5qz78" />
              {business.addressLine}
            </a>
            <span className="flex items-center gap-1.5" data-id="element-160" data-mp="2ho3pqsgn6lkd">
              <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-161" data-mp="2hpoe20cd589s" />
              {t(ui.hoursShort)}
            </span>
          </div>
          <a href={business.phoneHref} className="flex items-center gap-1.5 font-semibold text-white transition-colors duration-150 hover:text-leaf-light" data-id="element-162" data-mp="3abpqlsyhjc3j">
            <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-163" data-mp="35jg3ekor8q4y" />
            {business.phoneDisplay}
          </a>
        </div>
      </div>

      <div className="container-page flex h-[76px] items-center justify-between gap-4" data-id="element-164" data-mp="1wzcai6xfphp">
        <a href="#top" aria-label={t(ui.home)} className="rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-165" data-mp="3tbde28ggxc4h">
          <Logo data-id="element-166" data-mp="1re3860zvx2ii" />
        </a>

        <nav aria-label="Primary" className="hidden xl:block" data-id="element-167" data-mp="1rfxhsj5ph87a">
          <ul className="flex items-center" data-id="element-168" data-mp="1wbcw1c7ml648">
            {navItems.map(item => item.children ? <ServicesMenu key={item.href} item={item} data-id="element-169" data-mp="1hni1dqa24roi" /> : <li key={item.href} data-id="element-170" data-mp="1mljruw9tbta0">
                <a href={item.href} title={item.label[other]} className="whitespace-nowrap rounded-md px-2.5 py-2 text-[14px] font-medium text-navy-soft transition-colors duration-150 hover:bg-white/10 hover:text-white" data-id="element-171" data-mp="1mki5hvncjkcz">
                  {t(item.label)}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2 sm:gap-3" data-id="element-172" data-mp="2t36p4jv4xuqd">
          <LanguageToggle data-id="element-173" data-mp="2t3q35phnzyz4" />
          <a href="#contact" className="btn btn-green hidden min-h-[46px] whitespace-nowrap px-5 sm:inline-flex" data-id="element-174" data-mp="2y1zzi3f4l5mb">
            {t(ui.freeEstimate)}
          </a>
          <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? t(ui.closeMenu) : t(ui.openMenu)} className="flex h-12 w-12 items-center justify-center rounded-lg text-white transition-colors duration-150 hover:bg-white/10 xl:hidden" data-id="element-175" data-mp="mf6duz64li9p">
            {open ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-176" data-mp="153l0zbdboc58" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-177" data-mp="106bbxwtui2hx" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-178" data-mp="1f3vekx39rlkx">
        {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full max-h-[calc(100vh-76px)] overflow-y-auto border-t border-white/10 bg-navy shadow-xl xl:hidden" data-id="element-179" data-mp="1f2kbkzhnehuv">
            <ul className="container-page divide-y divide-white/10 py-2" data-id="element-180" data-mp="27xi3smvnkhxv">
              {navItems.map(item => <li key={item.href} data-id="element-181" data-mp="2cwlaebra6w7y">
                  <a href={item.href} onClick={() => setOpen(false)} className="flex min-h-[56px] items-center justify-between text-base font-semibold text-white" data-id="element-182" data-mp="2cxmmmjk19or9">
                    {t(item.label)}
                    <span lang={other} className="text-sm font-normal text-navy-soft" data-id="element-183" data-mp="1ka0kzgud8u71">
                      {item.label[other]}
                    </span>
                  </a>
                  {item.children && <ul className="mb-3 grid gap-2 sm:grid-cols-2" data-id="element-184" data-mp="1t713x7yo2033">
                      {item.children.map(c => <li key={c.href} data-id="element-185" data-mp="11hxyhov1mjov">
                          <a href={c.href} onClick={() => {
                  requestMarket(c.market);
                  setOpen(false);
                }} className="flex min-h-[56px] items-center gap-3 rounded-lg bg-white/10 px-4 text-[15px] font-medium text-white" data-id="element-186" data-mp="11gwo7mluq187">
                            {c.market === 'commercial' ? <Building2Icon className="h-4 w-4 text-leaf-light" aria-hidden="true" data-id="element-187" data-mp="k0sed4xihs28" /> : <HomeIcon className="h-4 w-4 text-leaf-light" aria-hidden="true" data-id="element-188" data-mp="f27e55i9f8ds" />}
                            {t(c.label)}
                          </a>
                        </li>)}
                    </ul>}
                </li>)}
            </ul>
            <div className="container-page grid gap-3 pb-6 sm:grid-cols-2" data-id="element-189" data-mp="3sfj6pjlwnf72">
              <a href="#contact" onClick={() => setOpen(false)} className="btn btn-green w-full" data-id="element-190" data-mp="3shn7hsoiby34">
                {t(ui.requestEstimate)}
              </a>
              <a href={business.phoneHref} className="btn btn-outline-white w-full" data-id="element-191" data-mp="3dsaqg4dqojo8">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-192" data-mp="3isgk1q3kkg8y" />
                {business.phoneDisplay}
              </a>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}